import { gql } from "@apollo/client";

export const schema = {
    changePassword: (query: string) => gql`
        mutation changePassword($userId: String!, $oldPassword: String!, $newPassword: String!) {
            changePassword(userId: $userId, oldPassword: $oldPassword, newPassword: $newPassword) {
                ${query}
            }
        }
    `,
    resetPassword: (query: string) => gql`
        mutation resetPassword($email: String, $phone: String, $password: String!) {
            resetPassword(email: $email, phone: $phone, password: $password) {
                ${query}
            }
        }
    `,
    verifyToken: (query: string) => gql`
        mutation verifyToken($email: String, $phone: String, $token: String!) {
            verifyToken(email: $email, phone: $phone, token: $token) {
                ${query}
            }
        }
    `,
    sendOTP: (query: string) => gql`
        mutation sendOTP($email: String, $phone: String) {
            sendOTP(email: $email, phone: $phone) {
                ${query}
            }
        }
    `,
    signUp: (query: string) => gql`
        mutation signUp($user: UserInput!, $password: String!, $adminRole: AdminRoleEnum) {
            signUp(user: $user, password: $password, adminRole: $adminRole) {
                ${query}
            }
        }
    `,
    login: (query: string) => gql`
        mutation login($email: String, $phone: String, $password: String!, $isAdmin: Boolean) {
            login(email: $email, phone: $phone, password: $password, isAdmin: $isAdmin) {
                ${query}
            }
        }
    `,
}
